var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nuxt-link',{staticClass:"button text-lp-body-2 px-4",attrs:{"to":{ path: _vm.to, query: Object.assign({}, this.$route.query) }}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }